/**
 * QuickActionsBar — one-tap actions for phone calls with a clinic:
 * call · WhatsApp · copy clinicId · +1 month · log payment · suspend · refresh.
 * Inline in the header on desktop; fixed bottom bar on mobile (CSS).
 */

import {
  Phone,
  WhatsappLogo,
  Copy,
  CalendarPlus,
  Wallet,
  Prohibit,
  ArrowCounterClockwise,
  ArrowClockwise,
  Trash,
} from "@phosphor-icons/react";
import HoverTip from "../../../../../components/ui/HoverTip";
import { buildWhatsappLink } from "../clinicDetailConstants";

function Action({ icon: Icon, label, onClick, href, tone = "", disabled = false, busy = false }) {
  const cls = `ncd2-action ${tone}${busy ? " is-busy" : ""}`;
  const content = (
    <>
      <Icon size={18} weight={tone ? "fill" : "regular"} />
      <span className="ncd2-action-label">{label}</span>
    </>
  );
  const el = href ? (
    <a className={cls} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" aria-label={label}>
      {content}
    </a>
  ) : (
    <button type="button" className={cls} onClick={onClick} disabled={disabled} aria-label={label}>
      {content}
    </button>
  );
  // Disabled buttons emit no mouse events — skip the tooltip wrapper for them
  return disabled ? el : <HoverTip text={label}>{el}</HoverTip>;
}

export default function QuickActionsBar({
  clinic,
  crm,
  onCopyId,
  onExtendMonth,
  onLogPayment,
  onToggleInactive,
  onDelete,
  onRefresh,
  busy,
}) {
  const phone = clinic.ownerPhone;
  // "+1 חודש" only means something for a one-time deal ("פעיל עד")
  const showExtend = crm?.paymentStatus === "paying" && crm?.billingCycle === "one_time";
  return (
    <nav className="ncd2-actions" aria-label="פעולות מהירות">
      <Action icon={Phone} label="התקשר" href={phone ? `tel:${phone}` : undefined} onClick={undefined} disabled={!phone} />
      <Action icon={WhatsappLogo} label="WhatsApp" href={phone ? buildWhatsappLink(phone) : undefined} disabled={!phone} />
      <Action icon={Copy} label="העתק Clinic ID" onClick={onCopyId} />
      {showExtend && <Action icon={CalendarPlus} label="הארך ״פעיל עד״ +1 חודש" onClick={onExtendMonth} disabled={busy} />}
      <Action icon={Wallet} label="רישום תשלום" onClick={onLogPayment} />
      <Action
        icon={clinic.inactiveByAdmin ? ArrowCounterClockwise : Prohibit}
        label={clinic.inactiveByAdmin ? "הפעל מחדש" : "השבת קליניקה"}
        onClick={onToggleInactive}
        tone={clinic.inactiveByAdmin ? "is-success" : "is-danger"}
        disabled={busy}
      />
      <Action icon={Trash} label="מחק קליניקה לצמיתות" onClick={onDelete} tone="is-danger" disabled={busy} />
      <Action icon={ArrowClockwise} label="רענון" onClick={onRefresh} busy={busy} />
    </nav>
  );
}
